import { createFileRoute } from "@tanstack/react-router";

import ChoosePage from "./-components/ChoosePage";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/cancel/choose"
)({
  component: ChoosePage,
});
